// TODO: Import this from @spine/events?
enum EventType {
  EntityEvent = 'EntityEvent',
  AlertEvent = 'AlertEvent',
  CustomEvent = 'CustomEvent',
  APIEvent = 'APIEvent',
  AutomationEvent = 'AutomationEvent',
  SchedulerEvent = 'SchedulerEvent',
  JobEvent = 'JobEvent',
  SecurityEvent = 'SecurityEvent',
  TimerEvent = 'TimerEvent',
  NotificationEvent = 'NotificationEvent',
  ActionEvent = 'ActionEvent',
  ErrorEvent = 'ErrorEvent'
}

export default EventType
